/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithSalesRepItemRequestBuilder, WithSalesRepItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/commissions/plans/active
 */
export interface ActiveRequestBuilder extends BaseRequestBuilder<ActiveRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.commissions.plans.active.item collection
     * @param salesRepId Unique identifier of the item
     * @returns {WithSalesRepItemRequestBuilder}
     */
     bySalesRepId(salesRepId: string) : WithSalesRepItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const ActiveRequestBuilderUriTemplate = "{+baseurl}/api/commissions/plans/active";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ActiveRequestBuilderNavigationMetadata: Record<Exclude<keyof ActiveRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    bySalesRepId: {
        requestsMetadata: WithSalesRepItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["salesRepId"],
    },
};
/* tslint:enable */
/* eslint-enable */
